import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async searchById(id) {
    let results = await HTTP.normal.get(
      `/accounts/${id}?include=accountable,profile`
    );
    return dataFormatter.deserialize(results.data);
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/user.js